import { OnboardingReducerFunction, SetSeenStepsAction } from '../Onboarding.actions';
import updateImmutable from 'immutability-helper';
import { OnboardingStateType } from '../OnboardingProvider';
import { Tooltip } from '../../constants/content';

export const seenStepsReducer: OnboardingReducerFunction<SetSeenStepsAction['payload']> = (state, payload) => {
  const { progress } = state;
  const initialIndexes: number[] = [];
  const completedStepsIndexesForUpdate = progress.reduce(
    (prev, current, index) => (payload.includes(current.key) && !current.completed ? [...prev, index] : prev),
    initialIndexes
  );
  const initialTuples: [number, number[]][] = [];
  const completedToulTipsTuplesForUpdate = progress.reduce<[number, number[]][]>((prev, current, stepIndex) => {
    const { tooltips } = current;
    const toolTipsIndexes = tooltips.reduce(
      (prevTool, currentTool, toolIndex) =>
        payload.includes(currentTool.id) && !currentTool.completed ? [...prevTool, toolIndex] : prevTool,
      initialIndexes
    );
    return toolTipsIndexes.length
      ? prev.length
        ? [...prev, [stepIndex, toolTipsIndexes]]
        : [[stepIndex, toolTipsIndexes]]
      : prev;
  }, initialTuples);
  let updated = updateImmutable(state, {});
  completedStepsIndexesForUpdate.forEach(index => {
    updated = updateImmutable<OnboardingStateType>(updated, {
      progress: {
        [index]: {
          completed: { $set: true }
        }
      }
    });
  });
  completedToulTipsTuplesForUpdate.forEach(tuple => {
    const [stepIndex, tooltipIndexes] = tuple;
    updated = updateImmutable<OnboardingStateType>(updated, {
      progress: {
        [stepIndex]: {
          tooltips: {
            $apply: (currentTooltips: Tooltip[]) =>
              currentTooltips.map((tooltip, index) =>
                tooltipIndexes.includes(index)
                  ? updateImmutable(tooltip, {
                      completed: { $set: true },
                      opened: { $set: false }
                    })
                  : tooltip
              )
          }
        }
      }
    });
  });

  const completedSteps = !updated.progress.some(step => !step.completed);
  if (completedSteps) {
    updated = updateImmutable(updated, {
      stepsCompleted: { $set: true }
    });
  }

  return updated;
};
